import { render, staticRenderFns } from "./PlayerAvatar.vue?vue&type=template&id=b4db486c&"
import script from "./PlayerAvatar.vue?vue&type=script&lang=js&"
export * from "./PlayerAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports